import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import * as JSTool from '../store/JSTool';
import { settingActions, settingObj } from '../store/SettingSlice';
import Game from '../store/Game.json';

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, EffectCoverflow, Mousewheel } from 'swiper/modules';

export default function Page1_mobile(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();

    React.useEffect(() => {

    }, []);

    return (
        <Stack sx={{
            width: 1,
            height: settingData.height,
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            bgcolor: 'white',
            backgroundImage: `url(${JSTool.getImgPath('bg-2.jpg')})`,
            backgroundSize: '100% 100%',
            color: 'black',
            pt: '20rem',
        }}>

            <Box
                component={'img'}
                src={JSTool.getImgPath(`${Game.roleAry[settingData.roleIndex].bigImg}`)}
                sx={{
                    visibility: !Game.roleAry[settingData.roleIndex].isShadow && 'hidden',
                    position: 'absolute',
                    width: 1,
                    zIndex: 1,
                }} />

            <Box
                component={'img'}
                src={JSTool.getImgPath(`skill_video/${Game.roleAry[settingData.roleIndex].bigImg}`)}
                sx={{
                    visibility: Game.roleAry[settingData.roleIndex].isShadow && 'hidden',
                    position: 'absolute',
                    height: '1000rem',
                    ml: '150rem',
                    zIndex: 1,
                    top: 0,
                    animation: 'roleAni 3s ease-in-out both infinite',
                }} />


            <Stack sx={{
                zIndex: 10,
                width: 1,
                backgroundImage: `url(${JSTool.getImgPath('alpha_round.png')})`,
                backgroundSize: '100% 100%',
                position: 'absolute',
                bottom: '170rem',
            }}>
                <Stack sx={{
                    ml: 3,
                    visibility: Game.roleAry[settingData.roleIndex].isShadow && 'hidden',
                    position: 'relative',
                }}>
                    <Typography sx={{
                        fontSize: '30rem',
                        fontWeight: 'bold',
                        mb: 2,
                        fontFamily: window.font0,
                        textShadow: "0 0 15px white"
                    }}>
                        {Game.roleAry[settingData.roleIndex].name}
                    </Typography>

                    <Stack sx={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Box
                            component={'img'}
                            src={JSTool.getImgPath('dif_flag.png')}
                            sx={{
                                height: '70rem',
                                mr: 2,
                            }} />

                        <Stack>
                            <Typography sx={{
                                fontSize: '15rem',
                                fontWeight: 'bold',
                                fontFamily: window.font0,
                            }}>
                                Role:  {Game.roleAry[settingData.roleIndex].defense}
                            </Typography>

                            <Stack sx={{
                                flexDirection: 'row',
                                alignItems: 'center',
                                mt: 1,
                            }}>
                                <Typography sx={{
                                    fontSize: '15rem',
                                    fontWeight: 'bold',
                                    fontFamily: window.font0,
                                }}>
                                    Difficulty:
                                </Typography>
                                {Array.from({ length: Game.roleAry[settingData.roleIndex].difficulty }, (_, index) => index)
                                    .map((v, i) => {
                                        return (
                                            <Box
                                                key={i}
                                                component={'img'}
                                                src={JSTool.getImgPath('ico-star.png')}
                                                sx={{
                                                    height: '20rem',
                                                    ml: 1,
                                                }} />
                                        );
                                    })}
                            </Stack>
                        </Stack>

                    </Stack>

                    <Stack sx={{
                        flexDirection: 'row',
                    }}>
                        <Stack sx={{
                            mt: 3,
                            flexDirection: 'row',
                            height: '30rem',
                            borderRadius: '15rem',
                            border: '1px solid black',
                            zIndex: 2,
                        }}>
                            <Typography
                                onClick={() => {
                                    dispatch(settingActions.setSkillIndex(0));
                                }}
                                sx={{
                                    fontSize: '14rem',
                                    color: settingData.skillIndex == 0 ? 'white' : 'black',
                                    bgcolor: settingData.skillIndex == 0 ? 'black' : 'transparent',
                                    borderRadius: '15rem',
                                    height: 1,
                                    lineHeight: '30rem',
                                    px: 1.8,
                                    cursor: 'pointer',
                                    fontFamily: window.font0,
                                }}>
                                {Game.roleAry[settingData.roleIndex].styleAry[0]}
                            </Typography>

                            <Typography
                                onClick={() => {
                                    dispatch(settingActions.setSkillIndex(1));
                                }}
                                sx={{
                                    fontSize: '14rem',
                                    color: settingData.skillIndex != 0 ? 'white' : 'black',
                                    bgcolor: settingData.skillIndex != 0 ? 'black' : 'transparent',
                                    borderRadius: '15rem',
                                    height: 1,
                                    lineHeight: '30rem',
                                    px: 1.8,
                                    cursor: 'pointer',
                                    fontFamily: window.font0,
                                }}>
                                {Game.roleAry[settingData.roleIndex].styleAry[1]}
                            </Typography>
                        </Stack>

                    </Stack>

                    <Box component={'div'}
                        sx={{
                            zIndex: 2,
                            color: 'black',
                            fontSize: '15rem',
                            lineHeight: '25rem',
                            mt: 1,
                            maxWidth: '300rem',
                            fontFamily: window.font0,
                            textShadow: "0 0 5px white",
                            minHeight: '150rem',
                        }}
                        dangerouslySetInnerHTML={{
                            __html:
                                `
                       ${Game.roleAry[settingData.roleIndex].styleInfoAry[settingData.skillIndex]}
                         `
                        }} />

                    <Box
                        onClick={() => {
                            dispatch(settingActions.showVideoAlert({
                                'imgUrl': JSTool.getImgPath(`skill_video/${Game.roleAry[settingData.roleIndex].sumbImgAry[settingData.skillIndex]}`),
                                'videoUrl': JSTool.getImgPath(`skill_video/${Game.roleAry[settingData.roleIndex].styleVideoAry[settingData.skillIndex]}`)
                            }));
                        }}
                        component={'img'}
                        src={JSTool.getImgPath('play_v.webp')}
                        sx={{
                            position: 'absolute',
                            width: '60rem',
                            top: 0,
                            bottom: 0,
                            left: '300rem',
                            zIndex: 20,
                            margin: 'auto',
                        }} />
                </Stack>

                <TypeView />
            </Stack>



        </Stack>
    );
}

function TypeView(props) {

    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();
    const [swiper, setSwiper] = React.useState(null);

    return (
        <Stack sx={{
            alignItems: 'center',
            justifyContent: 'center',
            mr: '100rem',
            width: 1,
        }}>

            <Swiper
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                }}
                loop={true}
                centeredSlides={true}
                slideToClickedSlide={true}
                slidesPerView={3}
                resistanceRatio={0}
                onSwiper={(sp) => {
                    setSwiper(sp);
                }}
                onSlideChangeTransitionEnd={(sp) => {
                    dispatch(settingActions.setRoleIndex(sp.realIndex));
                    dispatch(settingActions.setSkillIndex(0));
                }} >
                {Game.roleAry.map((item, index) => {
                    return (
                        <SwiperSlide key={index}>  <Item index={index} key={index} item={item} /></SwiperSlide>

                    );
                })}
            </Swiper>

        </Stack>
    );
}

function Item(props) {
    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();

    return (
        <Stack
            onClick={() => {
                dispatch(settingActions.setRoleIndex(props.index));
                dispatch(settingActions.setSkillIndex(0));
            }}
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
            }}>
            <Stack sx={{
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transitionDuration: '0.3s',
                '&:hover': {
                    opacity: 0.8,
                },
            }}>
                <Box
                    component={'img'}
                    src={props.index == settingData.roleIndex ? JSTool.getImgPath(`${props.item.icon}_sel.png`) : JSTool.getImgPath(`${props.item.icon}.png`)}
                    sx={{
                        height: '45rem',

                    }} />

                <Typography sx={{
                    fontSize: '11rem',
                    color: props.index == settingData.roleIndex ? '#1D91EC' : 'black',
                    fontFamily: window.font0,
                }}>
                    {props.item.name}
                </Typography>
            </Stack>

        </Stack>
    );
}